module.exports = __webpack_public_path__ + "img/dept-7.1e701969.svg";